<!--Copy right - © 2024 tecera gmbh-->
<footer class="footer-new" style="background-color:none;">
    Powered by 2kai
</footer>